import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7078/RealEstate";
	}
	setAgencyCode(e) {
		let t = this.baseUrl + "/SetAgencyCode";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (_(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processSetAgencyCode(e)));
	}
	processSetAgencyCode(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return g("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgencyCode(e) {
		let t = this.baseUrl + "/GetAgencyCode";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (_(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgencyCode(e)));
	}
	processGetAgencyCode(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return g("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPricing(e, t, n, r, i, a) {
		let o = this.baseUrl + "/GetPricing?";
		if (e == null) throw new globalThis.Error("The parameter 'suburb' must be defined and cannot be null.");
		if (o += "suburb=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		if (o += "state=" + encodeURIComponent("" + t) + "&", n == null) throw new globalThis.Error("The parameter 'postcode' must be defined and cannot be null.");
		o += "postcode=" + encodeURIComponent("" + n) + "&", r != null && (o += "section=" + encodeURIComponent("" + r) + "&"), i != null && (o += "listingType=" + encodeURIComponent("" + i) + "&"), o = o.replace(/[?&]$/, "");
		let s = {
			method: "GET",
			url: o,
			headers: { Accept: "application/json" },
			signal: a
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (_(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processGetPricing(e)));
	}
	processGetPricing(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return g("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.Buy = "Buy", e.Rent = "Rent", e.Sold = "Sold", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.Residential = "Residential", e.Land = "Land", e.Rural = "Rural", e;
}({}), h = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isRealEstateApiException = !0;
	static isRealEstateApiException(e) {
		return e.isRealEstateApiException === !0;
	}
};
function g(e, t, n, r, i) {
	throw i ?? new h(e, t, n, r, null);
}
function _(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var v = "realestate";
function y(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var b = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), y(r);
}, x = ({ baseApiUri: e, devMode: t, localUris: n }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	let r = n?.[v];
	return t && r ? r : `${e}/${v}`;
}, S = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = x(i), u = c, d = b(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(b(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, C = a({}), w = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = S(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(C.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, T = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(C), s;
	t[0] === a ? s = t[1] : (s = async () => a.setAgencyCode(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setAgencyCode: u,
		setAgencyCodePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, E = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(C), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgencyCode"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgencyCode(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, D = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgencyCode"] });
	}, e[0] = t, e[1] = n), n;
}, O = (e, t, n, i, a, s) => {
	let c = r(21), l = s === void 0 ? !0 : s, d = o(C), f;
	c[0] !== a || c[1] !== n || c[2] !== i || c[3] !== t || c[4] !== e ? (f = [
		"getPricing",
		e,
		t,
		n,
		i,
		a
	], c[0] = a, c[1] = n, c[2] = i, c[3] = t, c[4] = e, c[5] = f) : f = c[5];
	let p = f, m;
	c[6] !== d || c[7] !== a || c[8] !== n || c[9] !== i || c[10] !== t || c[11] !== e ? (m = (r) => {
		let { signal: o } = r;
		return d.getPricing(e, t, n, i, a, o);
	}, c[6] = d, c[7] = a, c[8] = n, c[9] = i, c[10] = t, c[11] = e, c[12] = m) : m = c[12];
	let h = l && !!d, g;
	c[13] !== p || c[14] !== m || c[15] !== h ? (g = {
		queryKey: p,
		queryFn: m,
		enabled: h
	}, c[13] = p, c[14] = m, c[15] = h, c[16] = g) : g = c[16];
	let { data: _, isPending: v, isError: y } = u(g), b;
	return c[17] !== _ || c[18] !== y || c[19] !== v ? (b = {
		data: _,
		isPending: v,
		isError: y
	}, c[17] = _, c[18] = y, c[19] = v, c[20] = b) : b = c[20], b;
}, k = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a) => {
		await t.invalidateQueries({ queryKey: [
			"getPricing",
			e,
			n,
			r,
			i,
			a
		] });
	}, e[0] = t, e[1] = n), n;
};
//#endregion
export { m as ListingType, C as RealEstateApiContext, h as RealEstateApiException, w as RealEstateApiProvider, f as RealEstateClient, v as RealEstateRoute, p as Section, E as useGetAgencyCode, O as useGetPricing, D as useInvalidateUseGetAgencyCode, k as useInvalidateUseGetPricing, S as useRealEstateClientContext, T as useSetAgencyCode };
